let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9S8EK")).then(() => parcelRequire('8if4g'));